import React, { useMemo, useRef, useEffect, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { elementIsVisibleInViewport } from '../../util/util';
import './profile.css'
import Form from "react-validation/build/form";
import { Button, Checkbox } from '../../util/ui'
import { DropDown } from '../../util/ui_components'
import CheckButton from "react-validation/build/button";
import Input from "react-validation/build/input";
import { reset_password_confirm } from '../../actions/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { change_profile_pic, change_instructor, change_user_fields } from '../../actions/profile';
import { LineChart, PieChart, AreaChart } from 'react-chartkick'
// import 'chartkick/chart.js'
import authHeader from '../../services/auth-header';
import { useJsonToCsv } from 'react-json-csv';
import axios from "axios";
import { config } from '../../config/client'
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import QuizProgress from "./quiz_progress";

import quiz_image from '../../assets/images/Quiz.png'
import activity_image from '../../assets/images/Activity.png'
import materials_image from '../../assets/images/Materials.png'

const exportToCsv = (data, sepProgress) => {
    console.log('inside export');
    console.log('exp', data)

    let resultData = [];
    const style = { padding: "5px" };

    // console.log("separation progress:", sepProgress)
    for (let key in data) {
        let entry = { "days": key, "total": data[key] }
        sepProgress.forEach(i => entry[i['name']] = "days" in i["data"] ?
            key in i["data"]["days"] ?
                i["data"]["days"][key] :
                0
            : 0)
        resultData.push(entry)
    }

    console.log('arr', resultData);
    return resultData
    // <JsonToCsv
    //   data={csvFormatDataArr(data)}
    //   filename={filename}
    //   fields={fields}
    //   style={style}
    //   // text={text}
    // />

    // <CsvDownload data={{"data":resultData}} />

}

const Activity = ({ tabpanelIndex, tabpanel, currentUser }) => {
    const { saveAsCsv } = useJsonToCsv();
    const { message } = useSelector(state => state.message);
    const { email: currentEmail } = useSelector(state => state.auth.user)
    const { progress, last_logged } = currentUser;
    const { role } = currentUser;
    const [progressData, setProgressData] = useState(progress)
    // 12 booleans from Checkbox to track wheather display a separate time series
    const [displayQuery, setDisplayQuery] = useState(false)
    const [displayClean, setDisplayClean] = useState(false)
    const [displayPrepro, setDisplayPrepro] = useState(false)
    const [displayFeaeng, setDisplayFeaeng] = useState(false)
    const [displayFeaslc, setDisplayFeaslc] = useState(false)
    const [displayAnalysis, setDisplayAnalysis] = useState(false)
    const [displayQuiz, setDisplayQuiz] = useState(false)
    const [displayStudentQuery, setDisplayStudentQuery] = useState(false)
    const [displayStudentClean, setDisplayStudentClean] = useState(false)
    const [displayStudentPrepro, setDisplayStudentPrepro] = useState(false)
    const [displayStudentFeaeng, setDisplayStudentFeaeng] = useState(false)
    const [displayStudentFeaslc, setDisplayStudentFeaslc] = useState(false)
    const [displayStudentAnalysis, setDisplayStudentAnalysis] = useState(false)
    const [displayStudentQuiz, setDisplayStudentQuiz] = useState(false)
    // xxxProgress store entire array of activity objects, xxxActivities for chart component
    const [personalProgress, setPersonalProgress] = useState([])
    const [personalActivities, setPersonalActivities] = useState([])
    const [studentProgress, setStudentProgress] = useState([])
    const [studentActivities, setStudentActivities] = useState([])

    const parentRef = useRef();
    const [option, setOption] = useState('days');
    const [studCount, setStudCount] = useState(0);
    const [instCount, setInstCount] = useState(0);
    const [studentDetails, setStudentDetails] = useState([]);
    const [instructorDetails, setInstructorDetails] = useState([]);
    const [dates, setDates] = useState({})
    const [allDates, setAllDates] = useState({})
    let [selectInstructor, setInstructor] = useState('See Instructor activity')
    let [selectStudent, setStudent] = useState('See Student activity')
    const [exportData, setExportData] = useState([])
    const [exportPersonalData, setExportPersonalData] = useState([])

    const fields = {
        "days": "Days",
        "total": "Total",
        "query": "Query",
        "cleaning": "Cleaning",
        "preprocessing": "Preprocessing",
        "feature engineering": "Feature Engineering",
        "feature selection": "Feature Selection",
        "analysis": "Analysis"
    };
    let today = new Date();
    let date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate();
    const filename = 'activity_' + date;

    useEffect(() => {
        if (!elementIsVisibleInViewport(parentRef.current)) return
    }, [exportData])
    useEffect(() => {
        fetchDetails();
        fetchPersonalActivities(currentEmail)
    }, []);
    const fetchDetails = async () => {
        const response = await fetch(config.endpoint + "/graph_details", {
            method: 'POST',
            body: JSON.stringify({ 'role': role }),
            headers: authHeader()
        });
        let json = await response.json();
        console.log("details:", json)
        if (json.students) {
            setStudCount(json.students)
        }
        if (json.instructors) {
            setInstCount(json.instructors)
        }
        if (json.dates) {
            setAllDates(json.dates);
            // setDates(json.dates);
            // setExportData([...exportToCsv(json.dates["days"], studentProgress)])
        }
        if (json.student_details) {
            setStudentDetails([...json.student_details, "All"]);

            console.log(json.student_details);
        }
        if (json.instructor_details) {
            setInstructorDetails([...json.instructor_details, "All"]);
            console.log("Instructor detail: ", json.instructor_details);
        }

        // const restest = await fetch(config.endpoint+'/get_activities', {method: 'GET', headers: authHeader()});
        // let jsontest = await restest.json();
        // console.log("jsontest", jsontest);
    };

    const fetchPersonalActivities = async (email) => {
        const res = await fetch(config.endpoint + "/get_activities", {
            method: 'POST',
            body: JSON.stringify({ 'email': email }),
            headers: authHeader()
        })
        let json = await res.json()
        let pro = [
            {
                "name": "query",
                "data": json.query_progress,
                "display": false,
            },
            {
                "name": "cleaning",
                "data": json.clean_progress,
                "display": false,
            },
            {
                "name": "preprocessing",
                "data": json.prepro_progress,
                "display": false,
            },
            {
                "name": "feature engineering",
                "data": json.feaeng_progress,
                "display": false,
            },
            {
                "name": "feature selection",
                "data": json.feaslc_progress,
                "display": false,
            },
            {
                "name": "analysis",
                "data": json.analysis_progress,
                "display": false,
            },
            {
                "name": "quiz",
                "data": json.quiz_progress,
                "display": false,
            }
        ]
        setPersonalProgress(pro)
        setExportPersonalData([...exportToCsv(progress["days"], pro)])
    }

    const updatePersonalProgress = (name, modify) => {
        const newProgress = personalProgress.map(item => {
            if (item.name == name) {
                return { ...item, display: modify };
            }
            return item
        })
        setPersonalProgress(newProgress)
    }

    useEffect(() => {
        let newActivities = personalProgress.filter(item => item.display)
        setPersonalActivities(newActivities)
    }, [displayQuery, displayClean, displayPrepro, displayFeaeng, displayFeaslc, displayAnalysis, displayQuiz])

    const updateStudentProgress = (name, modify) => {
        const newProgress = studentProgress.map(item => {
            if (item.name == name) {
                return { ...item, display: modify };
            }
            return item
        })
        setStudentProgress(newProgress)
    }

    useEffect(() => {
        let newActivities = studentProgress.filter(item => item.display)
        setStudentActivities(newActivities)
    }, [displayStudentQuery, displayStudentClean, displayStudentPrepro, displayStudentFeaeng, displayStudentFeaslc, displayStudentAnalysis, displayStudentQuiz])

    const fetchUserActivity = async (email) => {
        const response = await fetch(config.endpoint + "/get_user_activity", {
            method: 'POST',
            body: JSON.stringify({ 'email': email }),
            headers: authHeader()
        });
        let json = await response.json();
        if (json.progress) {
            setDates(json.progress);
        }

        const res2 = await fetch(config.endpoint + "/get_activities", {
            method: 'POST',
            body: JSON.stringify({ 'email': email }),
            headers: authHeader()
        })
        let json2 = await res2.json()
        let pro = [
            {
                "name": "query",
                "data": json2.query_progress,
                "display": false,
            },
            {
                "name": "cleaning",
                "data": json2.clean_progress,
                "display": false,
            },
            {
                "name": "preprocessing",
                "data": json2.prepro_progress,
                "display": false,
            },
            {
                "name": "feature engineering",
                "data": json2.feaeng_progress,
                "display": false,
            },
            {
                "name": "feature selection",
                "data": json2.feaslc_progress,
                "display": false,
            },
            {
                "name": "analysis",
                "data": json2.analysis_progress,
                "display": false,
            },
            {
                "name": "quiz",
                "data": json2.quiz_progress,
                "display": false,
            }
        ]
        setStudentProgress(pro)
        setExportData([...exportToCsv(json.progress["days"], pro)])
    }

    return <div className={`container mx-auto pl-10`} ref={parentRef}>
        <Form name="uploadFileForm" method="POST">
            {/* <ProfileSection currentUser={currentUser}/> */}
            <hr className="my-4" />
            <div className='w-full my-4'>
                <div className="flex flex-row justify-start items-center">
                    <h2 className="graph-heading p-5">
                        Last Logged In : {last_logged}
                    </h2>
                </div>
            </div>
            {(role === 'admin' || role === 'Instructor') &&
                <div className="flex flex-row justify-around  h-64 p-4 m-16">
                    {(role === 'admin' || role === 'Instructor') && <div className="count-box w-64 h-full">
                        <div className="top-box h-16">
                            <h1>Students</h1>
                        </div>
                        <div className="bottom-box h-48">
                            <h1>{studCount}</h1>
                        </div>
                    </div>}
                    {(role === 'admin') && <div className="count-box w-64 h-full">
                        <div className="top-box h-16">
                            <h1>Instructors</h1>
                        </div>
                        <div className="bottom-box h-48">
                            <h1>{instCount}</h1>
                        </div>
                    </div>}
                </div>
            }
            <div className="p-4 mr-16">
                <div className="flex justify-end my-4">
                    <Button text='days' customStyle={` ${option === 'days' ? 'button-active' : ''} h-10 my-4 w-16 rounded-l`} hasPadding={false} isRounded={false} onClick={(e) => {
                        e.preventDefault()
                        setOption(e.target.innerText)
                    }} />
                    <Button text='weeks' customStyle={` ${option === 'weeks' ? 'button-active' : ''} h-10 my-4 w-16`} hasPadding={false} isRounded={false} onClick={(e) => {
                        e.preventDefault()
                        setOption(e.target.innerText)
                    }} />
                    <Button text='months' customStyle={` ${option === 'months' ? 'button-active' : ''} h-10 my-4 w-16 rounded-r`} hasPadding={false} isRounded={false} onClick={(e) => {
                        e.preventDefault()
                        setOption(e.target.innerText)
                    }} />
                </div>
                <div className="flex flex-row justify-around">
                    <div>
                        {role === 'admin' &&
                            <div className='flex flex-row items-center' >
                                <DropDown className="fileSelect" /*disabled={!!instructorDetails.length} customStyle='w-72'*/ height='h-10' text={selectInstructor} items={instructorDetails.map((instructor) => {
                                    // Handle both old string format (like "All") and new object format
                                    if (typeof instructor === 'string') {
                                        return {
                                            name: instructor,
                                            onClick(e) {
                                                setInstructor(instructor);
                                                setStudent('See Student activity')
                                                if (instructor === "All") {
                                                    setDates(allDates);
                                                } else {
                                                    fetchUserActivity(instructor)
                                                }
                                            }
                                        };
                                    } else {
                                        // New object format with name, email, username
                                        const displayName = instructor.name && instructor.name.trim() !== '' ? instructor.name : instructor.username;
                                        const displayText = instructor.email && instructor.email.trim() !== '' ? `${displayName} (${instructor.email})` : displayName;
                                        const identifierForAPI = instructor.email || instructor.username; // Use email for API calls
                                        return {
                                            name: displayText,
                                            onClick(e) {
                                                setInstructor(displayText);
                                                setStudent('See Student activity')
                                                fetchUserActivity(identifierForAPI) // Use email/username for API
                                            }
                                        };
                                    }
                                })} />

                            </div>

                        }
                    </div>
                    <div>
                        {(role === 'Instructor' || role === 'admin') &&
                            <div className='flex flex-row items-center'>

                                <DropDown className="fileSelect" /*disabled={!!studentDetails.length} customStyle='w-72'*/ height='h-10' text={selectStudent} items={studentDetails.map((student) => {
                                    // Handle both old string format (like "All") and new object format
                                    if (typeof student === 'string') {
                                        return {
                                            name: student,
                                            onClick(e) {
                                                setStudent(student);
                                                if (role === 'admin') {
                                                    setInstructor('See Instructor activity')
                                                }
                                                if (student === "All") {
                                                    setDates(allDates);
                                                } else {
                                                    fetchUserActivity(student)
                                                }
                                            }
                                        };
                                    } else {
                                        // New object format with name, email, username
                                        const displayName = student.name && student.name.trim() !== '' ? student.name : student.username;
                                        const displayText = student.email && student.email.trim() !== '' ? `${displayName} (${student.email})` : displayName;
                                        const identifierForAPI = student.email || student.username; // Use email for API calls
                                        return {
                                            name: displayText,
                                            onClick(e) {
                                                setStudent(displayText);
                                                if (role === 'admin') {
                                                    setInstructor('See Instructor activity')
                                                }
                                                fetchUserActivity(identifierForAPI) // Use email/username for API
                                            }
                                        };
                                    }
                                })} />

                            </div>}

                    </div>

                </div>

            </div>
            <div className="w-4/5 flex align-center flex-col px-20">
                {role === 'admin' &&
                    <div className="flex flex-row justify-start items-center">
                        <h2 className="graph-heading my-5">Total hours for {
                            (selectInstructor === "All") ? 'all users' :
                                selectInstructor !== 'See Instructor activity' ?
                                    `${selectInstructor}` :
                                    (selectStudent === "All") ? 'all users' : selectStudent !== 'See Student activity' ? `${selectStudent}` : 'all users'}
                        </h2>
                    </div>}
                {role === 'Instructor' &&
                    <>
                        <div className="flex flex-row justify-between items-center">
                            <h2 className="graph-heading my-5">Activity of {selectStudent === "All" ? 'all students' : `${selectStudent}`}</h2>
                            <div title='click icon to download activity as a csv file'>Download Activity
                                {exportData.length > 0 ?
                                    <FontAwesomeIcon className="cursor-pointer" icon='download' /*className='p-3 profile-button'*/ onClick={(e) => {
                                        e.preventDefault();
                                        saveAsCsv({ data: exportData, fields, filename })
                                    }} />
                                    : ''}</div>
                        </div>

                        <div className='flex flex-row gap-4'>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentQuery} onChange={e => {
                                    updateStudentProgress("query", e.target.checked)
                                    setDisplayStudentQuery(e.target.checked)
                                }} />
                                <p>Query</p>
                            </div>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentClean} onChange={e => {
                                    updateStudentProgress("cleaning", e.target.checked)
                                    setDisplayStudentClean(e.target.checked)
                                }} />
                                <p>Cleaning</p>
                            </div>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentPrepro} onChange={e => {
                                    updateStudentProgress("preprocessing", e.target.checked)
                                    setDisplayStudentPrepro(e.target.checked)
                                }} />
                                <p>Preprocessing</p>
                            </div>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentFeaeng} onChange={e => {
                                    updateStudentProgress("feature engineering", e.target.checked)
                                    setDisplayStudentFeaeng(e.target.checked)
                                }} />
                                <p>Feature Engineering</p>
                            </div>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentFeaslc} onChange={e => {
                                    updateStudentProgress("feature selection", e.target.checked)
                                    setDisplayStudentFeaslc(e.target.checked)
                                }} />
                                <p>Feature Selection</p>
                            </div>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentAnalysis} onChange={e => {
                                    updateStudentProgress("analysis", e.target.checked)
                                    setDisplayStudentAnalysis(e.target.checked)
                                }} />
                                <p>Analysis</p>
                            </div>
                            <div className='flex items-center'>
                                <Checkbox checked={displayStudentQuiz} onChange={e => {
                                    updateStudentProgress("quiz", e.target.checked)
                                    setDisplayStudentQuiz(e.target.checked)
                                }} />
                                <p>Quiz</p>
                            </div>
                        </div>

                        <AreaChart xtitle={option} ytitle="Hours" data={[{ "name": "total", "data": dates[option] }, ...studentActivities.map(item => ({ "name": item.name, "data": item.data[option] }))]} />
                    </>}

                <div className="flex flex-row justify-between items-center">
                    <h2 className="graph-heading my-5">Your activity</h2>
                    <div title='click icon to download activity as a csv file'>Download Activity
                        {exportPersonalData.length > 0 ?
                            <button className="cursor-pointer">
                                <FontAwesomeIcon icon='download' /*className='p-3 profile-button'*/ onClick={(e) => {
                                    e.preventDefault();
                                    saveAsCsv({ data: exportPersonalData, fields, filename })
                                }} />
                            </button>
                            : ''}</div>
                </div>

                <div className='flex flex-row gap-4'>
                    <div className='flex items-center'>
                        <Checkbox checked={displayQuery} onChange={e => {
                            updatePersonalProgress("query", e.target.checked)
                            setDisplayQuery(e.target.checked)
                        }} />
                        <p>Query</p>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox checked={displayClean} onChange={e => {
                            updatePersonalProgress("cleaning", e.target.checked)
                            setDisplayClean(e.target.checked)
                        }} />
                        <p>Cleaning</p>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox checked={displayPrepro} onChange={e => {
                            updatePersonalProgress("preprocessing", e.target.checked)
                            setDisplayPrepro(e.target.checked)
                        }} />
                        <p>Preprocessing</p>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox checked={displayFeaeng} onChange={e => {
                            updatePersonalProgress("feature engineering", e.target.checked)
                            setDisplayFeaeng(e.target.checked)
                        }} />
                        <p>Feature Engineering</p>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox checked={displayFeaslc} onChange={e => {
                            updatePersonalProgress("feature selection", e.target.checked)
                            setDisplayFeaslc(e.target.checked)
                        }} />
                        <p>Feature Selection</p>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox checked={displayAnalysis} onChange={e => {
                            updatePersonalProgress("analysis", e.target.checked)
                            setDisplayAnalysis(e.target.checked)
                        }} />
                        <p>Analysis</p>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox checked={displayQuiz} onChange={e => {
                            updatePersonalProgress("quiz", e.target.checked)
                            setDisplayQuiz(e.target.checked)
                        }} />
                        <p>Quiz</p>
                    </div>
                </div>

                <div>
                    <LineChart xtitle={option} ytitle="Hours" /*data={progressData[option]}*/ /*data={[ 
                     {"name": "total", "data": progressData[option]},
                    {"name": "query", "data": queryProgress[option]},
                    ]}*/ data={[{"name": "total", "data": progressData[option]}, ...personalActivities.map(item=>({"name": item.name, "data":item.data[option]}))]} /> 
                </div>

            </div>


        </Form>
    </div>
}

const Dashboard = () => {
    const { user: currentUser } = useSelector((state) => state.auth);
    if (!currentUser) {
        return <Redirect to="/login" />;
    }
    const { role } = currentUser;
    console.log("Role: ", role);
    const section1Ref = useRef(null);
    const section2Ref = useRef(null);

    const location = useLocation();
    const [selectedStudent, setSelectedStudent] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const studentParam = params.get('student');
        if (studentParam) {
            setSelectedStudent(decodeURIComponent(studentParam));
            if (section2Ref.current) {
                section2Ref.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    // Pass selectedStudent to Activity as a prop

    return (
        <div className="bg-gray-100 h-full">
            <div className="">
                <nav className="flex flex-col w-full sm:flex-row justify-end">
                    {/* <Link to="/profile">
            <button type='button' className='btn btn-sm btn-secondary'>View Profile</button>
        </Link> */}
                </nav>
            </div>
            <section>
                {role === 'Student' &&
                    <Container fluid className="d-flex justify-content-center align-items-center vh-100">
                        <Row>
                            <Col xs={12} md={4} className="d-flex justify-content-center mb-4 mb-md-0">
                                <Link to="#" onClick={() => section2Ref.current && section2Ref.current.scrollIntoView({ behavior: 'smooth' })}>
                                    <Card className="text-center" style={{ width: '300px' }}>
                                        <Card.Img
                                            variant="top"
                                            // src="https://via.placeholder.com/200x150.png?text=Hands-on+Image"
                                            src={activity_image}
                                            className="card-img" />
                                        <Card.Footer className="text-white bg-dark">
                                            Activity
                                        </Card.Footer>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4} className="d-flex justify-content-center">
                                <Link to="/quiz/list">
                                    <Card className="text-center" style={{ width: '300px' }}>
                                        <Card.Img
                                            variant="top"
                                            // src="https://via.placeholder.com/200x150.png?text=Learning+Center+Image"
                                            src={quiz_image}
                                            className="card-img" />
                                        <Card.Footer className="text-white bg-dark">
                                            Quiz Repo
                                        </Card.Footer>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4} className="d-flex justify-content-center">
                                <Link to="/materials">
                                    <Card className="text-center" style={{ width: '300px' }}>
                                        <Card.Img
                                            variant="top"
                                            // src="https://via.placeholder.com/200x150.png?text=Learning+Center+Image"
                                            src={materials_image}
                                            className="card-img" />
                                        <Card.Footer className="text-white bg-dark">
                                            Lecture Slides
                                        </Card.Footer>
                                    </Card>
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                }
                {(role === 'Instructor' || role === 'admin') &&
                    <Container fluid className="d-flex justify-content-center align-items-center vh-100">
                        <Row>
                            <Col xs={12} md={4} className="d-flex justify-content-center mb-4 mb-md-0">
                                <Link to="#" onClick={() => section2Ref.current && section2Ref.current.scrollIntoView({ behavior: 'smooth' })}>
                                    <Card className="text-center" style={{ width: '350px' }}>
                                        <Card.Img
                                            variant="top"
                                            // src="https://via.placeholder.com/200x150.png?text=Hands-on+Image"
                                            src={activity_image}
                                            className="card-img" />
                                        <Card.Footer className="text-white bg-dark">
                                            Activity
                                        </Card.Footer>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4} className="d-flex justify-content-center">
                                <Link to="/quiz/list">
                                    <Card className="text-center" style={{ width: '350px' }}>
                                        <Card.Img
                                            variant="top"
                                            // src="https://via.placeholder.com/200x150.png?text=Learning+Center+Image"
                                            src={quiz_image}
                                            className="card-img" />
                                        <Card.Footer className="text-white bg-dark">
                                            Manage Quiz
                                        </Card.Footer>
                                    </Card>
                                </Link>
                            </Col>
                            <Col xs={12} md={4} className="d-flex justify-content-center">
                                <Link to="/materials">
                                    <Card className="text-center" style={{ width: '350px' }}>
                                        <Card.Img
                                            variant="top"
                                            // src="https://via.placeholder.com/200x150.png?text=Learning+Center+Image"
                                            src={materials_image}
                                            className="card-img" />
                                        <Card.Footer className="text-white bg-dark">
                                            Manage Learning Material
                                        </Card.Footer>
                                    </Card>
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                }
            </section>

            <section ref={section2Ref}>
                <>
                    {(role === 'Instructor' || role === 'admin') &&
                        <QuizProgress selectedStudent={selectedStudent} />
                    }
                    <Activity tabpanelIndex={2} tabpanel={null} currentUser={currentUser} selectedStudent={selectedStudent} />
                </>
            </section>

        </div>)

};

export default Dashboard;